import { gsap } from 'gsap';

const imageGradientEffect = (opts) => {
  gsap.to(opts.element, { background: opts.gradient, duration: opts.duration, alpha: opts.alpha });
};

export default imageGradientEffect;
